import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getCustomersByTenantId = createWrappedAsyncThunk(
  "topics/getCustomersByTenantId",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get("customers", {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  },
);
